import { render, staticRenderFns } from "./PrivateMessageCard.vue?vue&type=template&id=5e584a7a&"
import script from "./PrivateMessageCard.vue?vue&type=script&lang=js&"
export * from "./PrivateMessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports